import { useEffect } from 'react'
import { FieldValues, Path, PathValue, UseFormReturn } from 'react-hook-form'

export function useReviewFormRepeatedMultipleValues<
  F extends FieldValues = FieldValues
>({
  form,
  values,
  disabled
}: {
  form: UseFormReturn<F>
  values: {
    serverValue: PathValue<F, Path<F>>
    responsibleValue: PathValue<F, Path<F>>
    formProp: Path<F>
  }[]
  disabled?: boolean
}) {
  useEffect(() => {
    if (disabled) return
    values.forEach(({ formProp, responsibleValue, serverValue }) => {
      if (serverValue !== responsibleValue) return
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      form.setValue(formProp, serverValue as any)
    })
  }, [])
}

export function useReviewFormRepeatedMultipleArrayValues<
  F extends FieldValues = FieldValues,
  P extends Path<F> = Path<F>,
  V extends PathValue<F, P> = PathValue<F, P>
>({
  form,
  formProp,
  serverValue,
  responsibleValue,
  comparison,
  disabled
}: {
  form: UseFormReturn<F>
  formProp: P
  serverValue: V
  responsibleValue: V
  comparison: (a: V[number], b: V[number]) => boolean
  disabled?: boolean
}) {
  useEffect(() => {
    if (disabled) return
    form.setValue(
      formProp,
      responsibleValue.reduce((acc, responsibleSentItem) => {
        serverValue.forEach((serverItem) => {
          if (comparison(responsibleSentItem, serverItem)) {
            if (
              form
                .getValues(formProp)
                .some((formItem) => comparison(formItem, serverItem))
            )
              return
            acc.push(serverItem)
          }
        })
        return acc
      }, [])
    )
  }, [])
}
